import { render, staticRenderFns } from "./DialogCreateClient.vue?vue&type=template&id=3979a3ee&scoped=true"
import script from "./DialogCreateClient.vue?vue&type=script&lang=js"
export * from "./DialogCreateClient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3979a3ee",
  null
  
)

export default component.exports